<template>
  <div>
    <prohead></prohead>
    <div class="banner" style="background: url('../../static/img/k_bg.jpg');position: relative">
      <div style="position: absolute;left: 46%">新闻资讯</div>
    </div>
    <div class="banner_kai" >
      <div style="text-align: center">
        <div class="titlebox" style="padding-top: 65px">新闻资讯</div>
        <p class="title_fu">NEWS</p>
        <img style="margin-top: 10px;" src="../../static/img/biaoti.png" alt="">
      </div>

      <div class="banner_new" style="padding-top: 40px">
            <ul>
              <li v-for="item in data" @click="details(item.id)">
                <div class="new_img"><img :src="item.imgurl" alt=""></div>
                <div class="new-title">
<!--                  <h3>{{item.title}}</h3>-->
                  <span style="font-size: 24px;font-weight: bold;display: block">{{item.title}}</span>
                  <p class="depict">{{item.depict}}</p>
                  <p class="time" style="margin-top: 18px">{{item.create_time}}</p>
                </div>
              </li>
            </ul>
      </div>
      <div class="pagecon">
        <el-pagination
          background
          :current-page="listQuery.page"
          :limit.sync="listQuery.limit"
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :total="listQuery.total">
        </el-pagination>
      </div>


    </div>
    <Profooter></Profooter>
  </div>

</template>

<script>
import Prohead from '../components/Prohead'
import Profooter from "../components/Profooter";
export default {
  name: "index",
  components: {Prohead,Profooter},
  data() {
    return {
      data:[],
      url:'http://api.kxwg123.com/',
      total: '',
      listQuery: {
        page: 1,
        limit: 5,
        total:''
      },
      totalCount:''
    }
  },
  created() {
    this.listQuery.page = this.$route.query.page
    this.showPhoto()
    this.show()
  },
  mounted() {


  },
  methods: {
    handleCurrentChange(val){
      console.log(val)
      this.listQuery.page = val
      this.showPhoto()
    },
    details(id){
      this.$router.push('/newdetails?id='+id+'&page='+this.listQuery.page)

    },
    showPhoto(){
      let formdata = new FormData()
      formdata.append('page',this.listQuery.page)
      formdata.append('limit',this.listQuery.limit)

      this.$axios.post('/index/Article/ArticleList',formdata).then(res => {
          this.data = res.data.data
          this.listQuery.total = res.data.totalCount *2
          console.log(this.listQuery.total)
      });
    },

    show(){

    },
  }
}
</script>

<style scoped>
.new-title span:hover{
  color: #D76056;
  cursor: pointer;
}
.new_img img{
  cursor: pointer;
  transition: all 0.6s;

}
.new_img img:hover{
  cursor: pointer;
  transform: scale(1.1);

}
.pagecon{
  text-align: center;
  margin: 0 auto;
  padding: 30px 0;
}
.depict{
  height:46px ;
  width: 900px;
  margin-top: 10px;
  font-size: 16px;

}
.new-title .time{
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 30px;
  margin-top: 10px;
  display: block;
  width: 900px;
  height: 30px;

}

.new_img{
  width: 280px;
  height: 160px;
  border-radius: 10px;
  margin-right: 30px;
}
.new_img img{
  width: 280px;
  height: 160px;
  border-radius: 10px;
}
.banner_new li{
  width: 1300px;
  height: 160px;
  border-bottom: 1px dotted #C5C5C5;
  padding:  36px 0px ;
}
.banner_new li div{
  float: left;
}
.banner_pin div{
  float: left;
}
.box3{
  margin: 0 auto;
  width: 100%;

  height: 618px;
  //background: url("../../static/img/bg2.jpg");
}
.box_banner2{
  width: 1300px;
  margin: 0 auto;
  height: 620px;
  text-align: center;
}
.box_imgbanner div{
  float: left;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 36px;
  text-align: left;
}
.box_imgbanner{
  margin-top: 60px;
}
.banner_pintext{
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.titlebox{
  text-align: center;
  font-size: 40px;
  font-weight: 500;
}
.title_fu{
  font-size: 18px;
  font-weight: 400;
  color: #666666;
  text-align: center;
}
.banner{
  height: 300px;
  font-size: 40px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 300px;
  text-align: center;
}
.banner_kai{
  width: 1300px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/newadd.vue